import { CommonModule } from '@angular/common'
import { Component, OnInit, inject } from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { Observable } from 'rxjs'
import { SignalRService } from 'src/app/core/services/signalr/signalr-service'
import { StaffService } from 'src/app/core/services/staff/staff.service'
import { CardComponent } from 'src/app/shared/components/card/card.component'
import { ButtonComponent } from 'src/app/shared/components/form-elements/button/button.component'
import { InputDropdownComponent } from 'src/app/shared/components/form-elements/input-dropdown/input-dropdown.component'
import { InputTextareaComponent } from 'src/app/shared/components/form-elements/input-textarea/input-textarea.component'
import { InputComponent } from 'src/app/shared/components/form-elements/input/input.component'
import { StaffListItem } from 'src/app/shared/interfaces/staff/staff-list-item.interface'

@Component({
    selector: 'sf-tester',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        InputComponent,
        InputTextareaComponent,
        InputDropdownComponent,
        ButtonComponent,
        CardComponent,
    ],
    templateUrl: './tester.component.html',
    styleUrls: ['./tester.component.scss'],
})
export class TesterComponent implements OnInit {
    private signalRService: SignalRService = inject(SignalRService)
    private staffService = inject(StaffService)

    types = ['success', 'danger', 'warning']
    singleUserform!: FormGroup
    groupForm!: FormGroup
    staff$!: Observable<StaffListItem[]>

    constructor(private fb: FormBuilder) {}

    ngOnInit(): void {
        this.staff$ = this.staffService.getAllStaff()

        this.singleUserform = this.fb.group({
            username: ['', Validators.required],
            title: ['', Validators.required],
            message: ['', Validators.required],
            type: ['', Validators.required],
        })

        this.groupForm = this.fb.group({
            title: ['', Validators.required],
            message: ['', Validators.required],
            type: ['', Validators.required],
        })
    }

    sendSingle(): void {
        if (this.singleUserform.invalid) {
            alert('invalid form')
            return
        }

        const { username, title, message, type } = this.singleUserform.value
        this.sendSignalMessage(username, title, message, type)
    }

    sendGroupMessage(): void {
        if (this.groupForm.invalid) {
            alert('invalid form')
            return
        }

        const { title, message, type } = this.groupForm.value

        this.sendSignalMessageToGroup(title, message, type)
    }

    sendSignalMessage(username: string, title: string, message: string, type: string): void {
        this.signalRService.connection
            .invoke('SendMessageToUser', username, title, message, type)
            .catch((err) => console.error(err.toString()))
    }

    sendSignalMessageToGroup(title: string, message: string, type: string): void {
        this.signalRService.connection
            .invoke('SendMessageToAllUsersInMyCompany', title, message, type)
            .catch((err) => console.error(err.toString()))
    }
}
